import { isLoggedInAtom } from "@/modules/api/apikey.store.ts";
import LoginsRoot from "@/modules/login/LoginsRoot.tsx";
import { AuthenticatedRootProviders } from "@/modules/main/MainRoot.tsx";
import { createLazyFileRoute, Outlet } from "@tanstack/react-router";
import { useAtomValue } from "jotai/react";

export const Route = createLazyFileRoute("/_main_custom")({
    component: MainCustomRoutes,
});

function MainCustomRoutes() {
    const loggedIn = useAtomValue(isLoggedInAtom);
    if (!loggedIn) {
        return <LoginsRoot />;
    }

    return (
        <AuthenticatedRootProviders>
            <Outlet />
        </AuthenticatedRootProviders>
    );
}
